<template>
  <div class="forgot-password">
    <div class="frow centered">
      <div
        v-if="emailSent"
        class="box"
      >
        Reset email sent. You will see an email in your inbox soon with reset instructions.
        (If you don't see an email, double check your spam folder)
      </div>
      <div
        v-else
        class="box"
      >
        Forgot your Password? Enter your email below to receive a reset link.
        <label class="label">
          Email:
        </label>
        <input
          v-model="email"
          class="input"
          type="text"
          placeholder="Email"
        >
        <br>
        <br>
        <button
          class="button"
          :class="{'is-loading': sendingEmail}"
          :disabled="email === ''"
          @click="sendEmail"
        >
          Send Reset Email
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',
  components: {},
  data() {
    return {
      email: '',
      sendingEmail: false,
      emailSent: false,
    };
  },
  computed: {
    API() {
      return this.$API;
    },
  },
  methods: {
    sendEmail() {
      this.sendingEmail = true;
      this.axios
        .post(`${this.$API}/auth/forgot-password`, {
          email: this.email,
        })
        .then((response) => {
          console.log('Data', response.data);
          this.sendingEmail = false;
          this.emailSent = true;
          setTimeout(() => {
            this.$router.push('/admin/login');
          }, 6000);
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
<style lang="scss" scoped>
.forgot-password {
  background-color: #fff;
  overflow: hidden;
  height: 100%;
  width: 100%;
}
.box {
  height: 300px;
  width: 300px;
}
</style>
